import { render, staticRenderFns } from "./GamePage.vue?vue&type=template&id=ee073c0c&scoped=true"
import script from "./GamePage.vue?vue&type=script&lang=js"
export * from "./GamePage.vue?vue&type=script&lang=js"
import style0 from "./GamePage.vue?vue&type=style&index=0&id=ee073c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee073c0c",
  null
  
)

export default component.exports